// Permission
export class PermissionPivot {
  role_id?: string;
  permission_id?: number;
  scope?: string | null;

  constructor(init?: Partial<PermissionPivot>) {
    Object.assign(this, init);
  }
}

export class Permission {
  id?: number;
  name?: string;
  scoopable?: boolean;
  created_at?: string;
  updated_at?: string;
  deleted_at?: string | null;
  pivot?: PermissionPivot;

  constructor(init?: Partial<Permission>) {
    Object.assign(this, init);
  }
}

// Permission Dependencies
export class PermissionDependencies {
  [key: string]: string[];

  constructor(init?: Partial<PermissionDependencies>) {
    Object.assign(this, init);
  }
}

// Permission Config
export class PermissionGroup {
  name?: string;
  items?: Permission[];

  constructor(init?: Partial<PermissionGroup>) {
    Object.assign(this, init);
  }
}

export class PermissionConfig {
  title?: string;
  icon?: string;
  groups?: PermissionGroup[];

  constructor(init?: Partial<PermissionConfig>) {
    Object.assign(this, init);
  }
}
